/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class TimepickerConfig {

    constructor (private schemaFormProvider: any,
                 private schemaFormDecoratorsProvider: any,
                 private sfPathProvider: any) {

        let timepicker: any = function(name: any, schema: any, options: any): any {
            var f: any;
            if (schema.type === 'string' && schema.format === 'time') {
                f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'timepicker';
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        schemaFormProvider.defaults.string.unshift(timepicker);

        schemaFormDecoratorsProvider.addMapping(
            'bootstrapDecorator',
            'timepicker',
            'timepicker.html'
        );
    }

    public static configure(schemaFormProvider: any, schemaFormDecoratorsProvider: any, sfPathProvider: any): TimepickerConfig {
        return new TimepickerConfig(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider);
    }
}

TimepickerConfig.configure.$inject = [
    'schemaFormProvider',
    'schemaFormDecoratorsProvider',
    'sfPathProvider'
];

class TimepickerRun {
    constructor ($templateCache: angular.ITemplateCacheService) {
        $templateCache.put('timepicker.html', `
            <div ng-class="{'has-error': hasError(), 'required-field': form.required}" class="form-group">
                <div class="row">
                    <div class="col-sm-4">
                        <label ng-show="showTitle()" class="control-label">{{form.title || form.key[0]}}</label>
                    </div>
                    <div class="col-sm-6">
                        <schematimepicker model="$$value$$"></schematimepicker><span sf-message="form.description" class="help-block"></span>
                    </div>
                </div>
            </div>
        `);
    }

    public static run($templateCache: angular.ITemplateCacheService): TimepickerRun {
        return new TimepickerRun($templateCache);
    }
}

TimepickerRun.$inject = ['$templateCache'];

angular.module('schemaForm').config(TimepickerConfig.configure).run(TimepickerRun.run);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/configs/timepicker.config.ts